import { render } from "./offerings-form--item.vue?vue&type=template&id=a635529a&scoped=true&ts=true"
import script from "./offerings-form--item.vue?vue&type=script&lang=ts"
export * from "./offerings-form--item.vue?vue&type=script&lang=ts"

import "./offerings-form--item.vue?vue&type=style&index=0&id=a635529a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a635529a"]])

export default __exports__